import { chakra } from '@chakra-ui/react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

type ActionButtonTone = 'default' | 'good' | 'warn' | 'blue';

const toneProps: Record<
  ActionButtonTone,
  {
    borderWidth?: string;
    borderColor?: string;
    bg?: string;
    color: string;
    _hover: { bg?: string; color?: string };
  }
> = {
  default: {
    color: 'text.muted',
    _hover: { color: 'text.primary' },
  },
  good: {
    borderWidth: '1px',
    borderColor: 'signal.good/30',
    bg: 'signal.good/10',
    color: 'signal.good',
    _hover: { bg: 'signal.good/15' },
  },
  warn: {
    borderWidth: '1px',
    borderColor: 'signal.warn/30',
    bg: 'signal.warn/10',
    color: 'signal.warn',
    _hover: { bg: 'signal.warn/15' },
  },
  blue: {
    borderWidth: '1px',
    borderColor: 'signal.blue/30',
    bg: 'signal.blue/10',
    color: 'text.primary',
    _hover: { bg: 'signal.blue/15' },
  },
};

interface ActionButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: ActionButtonTone;
  children: ReactNode;
}

export function ActionButton({ tone = 'default', className, children, ...props }: ActionButtonProps) {
  const t = toneProps[tone];
  return (
    <chakra.button
      type="button"
      layerStyle="glassPanel"
      borderRadius="oqPanel"
      px="4"
      py="3"
      fontSize="sm"
      fontWeight="semibold"
      transition="all 0.2s"
      borderWidth={t.borderWidth}
      borderColor={t.borderColor}
      bg={t.bg}
      color={t.color}
      _hover={t._hover}
      className={className}
      {...props}
    >
      {children}
    </chakra.button>
  );
}